export default function () {
    this.conf.offCanvas.page.noSelector.push('#olark');
}
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/wrappers/olark/mmenu.olark.js
// module id = 490
// module chunks = 0